module.exports = __webpack_public_path__ + "img/social-networks.d459887b.svg";